export const MOCK_USER = {
  id: 1, nome: "Henrique Leitão", email: "henrique@slicedgroup.com", role: "admin",
};

const FATURAS_BASE = [
  { id: 1,  numero_documento: "FT 2025/1087", nome_emitente: "EDP Comercial SA",     nif_emitente: "501001041", data_documento: "2025-06-15", nome_empresa: "Slice Dimension",  nif_recetor: "123456789", valor_total: 2340.50, drive_ok: true,  sheets_ok: true,  pago: false, possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 2,  numero_documento: "FT 2025/1086", nome_emitente: "Galp Energia SA",       nif_emitente: "500276006", data_documento: "2025-06-14", nome_empresa: "Everglobal SA",    nif_recetor: "987654321", valor_total: 890.00,  drive_ok: false, sheets_ok: false, pago: false, possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 3,  numero_documento: "FT 2025/1085", nome_emitente: "NOS Comunicações SA",   nif_emitente: "508184875", data_documento: "2025-06-13", nome_empresa: "Slice Dimension",  nif_recetor: "123456789", valor_total: 156.80,  drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 4,  numero_documento: "FT 2025/1084", nome_emitente: "TMN Portugal SA",       nif_emitente: "501213982", data_documento: "2025-06-12", nome_empresa: "Global Rock Lda",  nif_recetor: "555666777", valor_total: 320.00,  drive_ok: true,  sheets_ok: false, pago: false, possivel_duplicado: true,  tipo_documento: "Fatura_Fornecedor" },
  { id: 5,  numero_documento: "FT 2025/1083", nome_emitente: "MEO SA",                nif_emitente: "502399694", data_documento: "2025-06-11", nome_empresa: "Everglobal SA",    nif_recetor: "987654321", valor_total: 5200.00, drive_ok: true,  sheets_ok: true,  pago: false, possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 6,  numero_documento: "FT 2025/1082", nome_emitente: "Vodafone Portugal",     nif_emitente: "501003956", data_documento: "2025-06-10", nome_empresa: "Slice Dimension",  nif_recetor: "123456789", valor_total: 78.40,   drive_ok: false, sheets_ok: false, pago: false, possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 7,  numero_documento: "FS 2025/0312", nome_emitente: "Slice Dimension Lda",   nif_emitente: "123456789", data_documento: "2025-06-09", nome_empresa: "Slice Dimension",  nif_recetor: "123456789", valor_total: 12500.00,drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: false, tipo_documento: "Fatura_Cliente" },
  { id: 8,  numero_documento: "RV 2025/0061", nome_emitente: "Slice Dimension Lda",   nif_emitente: "123456789", data_documento: "2025-06-05", nome_empresa: "Slice Dimension",  nif_recetor: "123456789", valor_total: 3200.00, drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: false, tipo_documento: "Recibo_Vencimento" },
  { id: 9,  numero_documento: "FT 2025/1080", nome_emitente: "Santander Portugal",    nif_emitente: "500843555", data_documento: "2025-06-03", nome_empresa: "Stratosphere Lda", nif_recetor: "111222333", valor_total: 450.00,  drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 10, numero_documento: "FT 2025/1079", nome_emitente: "CTT Expresso SA",       nif_emitente: "502695370", data_documento: "2025-06-02", nome_empresa: "Global Rock Lda",  nif_recetor: "555666777", valor_total: 89.90,   drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 11, numero_documento: "FT 2025/1078", nome_emitente: "Seguradora Fidelidade",  nif_emitente: "500919177", data_documento: "2025-05-30", nome_empresa: "Everglobal SA",    nif_recetor: "987654321", valor_total: 1840.00, drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: false, tipo_documento: "Fatura_Fornecedor" },
  { id: 12, numero_documento: "FT 2025/1077", nome_emitente: "Galp Energia SA",       nif_emitente: "500276006", data_documento: "2025-05-28", nome_empresa: "Slice Dimension",  nif_recetor: "123456789", valor_total: 320.00,  drive_ok: true,  sheets_ok: true,  pago: true,  possivel_duplicado: true,  tipo_documento: "Fatura_Fornecedor" },
];

export function getMockData(path) {
  // ── Stats ──────────────────────────────────────────────────────────────
  if (path.includes("/api/stats")) return {
    faturas: { total: 347, valor_total: 142850.60, completas: 312, incompletas: 35 },
    emails:  { total: 89, ok: 84, erro: 5 },
  };

  // ── Empresas ───────────────────────────────────────────────────────────
  if (path.includes("/api/empresas")) return [
    { nif: "123456789", nome: "Slice Dimension Lda",  ativa: true, total_faturas: 147, valor_total: 78400.20 },
    { nif: "987654321", nome: "Everglobal SA",         ativa: true, total_faturas: 98,  valor_total: 38250.80 },
    { nif: "555666777", nome: "Global Rock Lda",       ativa: true, total_faturas: 62,  valor_total: 19850.40 },
    { nif: "111222333", nome: "Stratosphere Lda",      ativa: true, total_faturas: 40,  valor_total: 6349.20  },
  ];

  // ── Faturas ────────────────────────────────────────────────────────────
  if (path.includes("/api/faturas/incompletas")) return FATURAS_BASE.filter(f => !f.drive_ok || !f.sheets_ok);
  if (path.includes("/api/faturas")) return FATURAS_BASE;

  // ── Timeline ───────────────────────────────────────────────────────────
  if (path.includes("/api/timeline")) return [
    { mes: "2025-06", valor: 48500, total: 87 },
    { mes: "2025-05", valor: 52300, total: 94 },
    { mes: "2025-04", valor: 39800, total: 71 },
    { mes: "2025-03", valor: 61200, total: 108 },
    { mes: "2025-02", valor: 44100, total: 79 },
    { mes: "2025-01", valor: 35600, total: 63 },
  ];

  // ── Alertas ────────────────────────────────────────────────────────────
  if (path.includes("/api/alertas")) return [
    { id: 1, nivel: "warn",  severidade: "warn",     titulo: "Possível fatura duplicada",  desc: "FT 2025/1084 e FT 2025/1077 — Galp Energia" },
    { id: 2, nivel: "info",  severidade: "info",     titulo: "35 faturas pendentes",       desc: "Aguardam upload Drive ou Sheets" },
    { id: 3, nivel: "warn",  severidade: "warn",     titulo: "5 emails com erro",          desc: "Não foi possível processar alguns emails" },
  ];

  // ── Actividade recente ─────────────────────────────────────────────────
  if (path.includes("/api/actividade")) return [
    { tipo: "fatura_ok", label: "FT 2025/1087 — EDP Comercial SA",    empresa: "Slice Dimension", ts: new Date(Date.now() -  5*60000).toISOString() },
    { tipo: "fatura_ok", label: "FT 2025/1085 — NOS Comunicações",    empresa: "Slice Dimension", ts: new Date(Date.now() - 18*60000).toISOString() },
    { tipo: "pendente",  label: "FT 2025/1086 — Galp Energia",        empresa: "Everglobal SA",   ts: new Date(Date.now() - 32*60000).toISOString() },
    { tipo: "fatura_ok", label: "FT 2025/1083 — MEO SA",              empresa: "Everglobal SA",   ts: new Date(Date.now() -  2*3600000).toISOString() },
    { tipo: "erro",      label: "Erro no processamento email",         empresa: "Global Rock Lda", ts: new Date(Date.now() -  3*3600000).toISOString() },
    { tipo: "extrato",   label: "Extrato bancário importado",          empresa: "Slice Dimension", ts: new Date(Date.now() -  5*3600000).toISOString() },
    { tipo: "fatura_ok", label: "FT 2025/1080 — Santander Portugal",  empresa: "Stratosphere",    ts: new Date(Date.now() -  8*3600000).toISOString() },
  ];

  // ── Agente config ──────────────────────────────────────────────────────
  if (path.includes("/api/agente/config")) return {
    last_run_status:   "ok",
    last_run_em:       new Date(Date.now() - 12*60000).toISOString(),
    schedule_interval: "1h",
    email_check:       true,
    drive_enabled:     true,
    sheets_enabled:    true,
  };

  // ── Arquivo Drive ──────────────────────────────────────────────────────
  if (path.includes("/api/arquivo")) return [
    {
      nif: "123456789", nome: "Slice Dimension Lda", total_ficheiros: 48,
      periodos: [
        {
          periodo: "2025-06", total_ficheiros: 15, valor_total: 28540.20,
          ficheiros: [
            { id: 1, numero_documento: "FT 2025/1087", nome_emitente: "EDP Comercial SA",   data_documento: "2025-06-15", valor_total: 2340.50, drive_link: "https://drive.google.com/file/d/1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgVE2upms/view", tipo_documento: "Fatura_Fornecedor" },
            { id: 3, numero_documento: "FT 2025/1085", nome_emitente: "NOS Comunicações SA",data_documento: "2025-06-13", valor_total: 156.80,  drive_link: "https://drive.google.com/file/d/1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgVE2upms/view", tipo_documento: "Fatura_Fornecedor" },
            { id: 7, numero_documento: "FS 2025/0312", nome_emitente: "Slice Dimension Lda",data_documento: "2025-06-09", valor_total: 12500.00,drive_link: "https://drive.google.com/file/d/1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgVE2upms/view", tipo_documento: "Fatura_Cliente" },
            { id: 8, numero_documento: "RV 2025/0061", nome_emitente: "Slice Dimension Lda",data_documento: "2025-06-05", valor_total: 3200.00, drive_link: "https://drive.google.com/file/d/1BxiMVs0XRA5nFMdKvBdBZjgmUUqptlbs74OgVE2upms/view", tipo_documento: "Recibo_Vencimento" },
          ],
        },
        {
          periodo: "2025-05", total_ficheiros: 18, valor_total: 32100.00,
          ficheiros: [
            { id: 12, numero_documento: "FT 2025/1077", nome_emitente: "Galp Energia SA",  data_documento: "2025-05-28", valor_total: 320.00,  drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
            { id: 20, numero_documento: "FS 2025/0298", nome_emitente: "Slice Dimension",   data_documento: "2025-05-15", valor_total: 14800.00, drive_url: "#", tipo_documento: "Fatura_Cliente" },
          ],
        },
        {
          periodo: "2025-04", total_ficheiros: 15, valor_total: 18340.00,
          ficheiros: [
            { id: 30, numero_documento: "FT 2025/0960", nome_emitente: "EDP Comercial SA",  data_documento: "2025-04-12", valor_total: 2100.00, drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
          ],
        },
      ],
    },
    {
      nif: "987654321", nome: "Everglobal SA", total_ficheiros: 35,
      periodos: [
        {
          periodo: "2025-06", total_ficheiros: 10, valor_total: 12450.00,
          ficheiros: [
            { id: 5, numero_documento: "FT 2025/1083", nome_emitente: "MEO SA",             data_documento: "2025-06-11", valor_total: 5200.00, drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
            { id: 11,numero_documento: "FT 2025/1078", nome_emitente: "Seguradora Fidelidade",data_documento: "2025-05-30",valor_total: 1840.00, drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
          ],
        },
        {
          periodo: "2025-05", total_ficheiros: 12, valor_total: 14200.00,
          ficheiros: [
            { id: 40, numero_documento: "FT 2025/1060", nome_emitente: "Galp Energia SA",   data_documento: "2025-05-20", valor_total: 890.00,  drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
          ],
        },
      ],
    },
    {
      nif: "555666777", nome: "Global Rock Lda", total_ficheiros: 22,
      periodos: [
        {
          periodo: "2025-06", total_ficheiros: 8, valor_total: 6200.00,
          ficheiros: [
            { id: 10, numero_documento: "FT 2025/1079", nome_emitente: "CTT Expresso SA",   data_documento: "2025-06-02", valor_total: 89.90,   drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
          ],
        },
      ],
    },
    {
      nif: "111222333", nome: "Stratosphere Lda", total_ficheiros: 12,
      periodos: [
        {
          periodo: "2025-06", total_ficheiros: 5, valor_total: 3400.00,
          ficheiros: [
            { id: 9, numero_documento: "FT 2025/1080", nome_emitente: "Santander Portugal", data_documento: "2025-06-03", valor_total: 450.00,  drive_url: "#", tipo_documento: "Fatura_Fornecedor" },
          ],
        },
      ],
    },
  ];

  // ── Estatísticas / Análise ─────────────────────────────────────────────
  if (path.includes("/api/estatisticas")) return {
    totais: {
      total_docs:  347,
      valor_total: 142850.60,
      receitas:    89300.20,
      compras:     48200.40,
      salarios:     5350.00,
    },
    trend: [
      { mes: "2025-01", receitas: 14200, despesas: 9800  },
      { mes: "2025-02", receitas: 18500, despesas: 12400 },
      { mes: "2025-03", receitas: 24800, despesas: 15600 },
      { mes: "2025-04", receitas: 16200, despesas: 10900 },
      { mes: "2025-05", receitas: 21400, despesas: 13800 },
      { mes: "2025-06", receitas: 19800, despesas: 11200 },
    ],
    por_tipo: [
      { tipo_documento: "Fatura_Fornecedor", n: 198, valor: 48200.40 },
      { tipo_documento: "Fatura_Cliente",    n: 112, valor: 89300.20 },
      { tipo_documento: "Recibo_Vencimento", n:  24, valor:  5350.00 },
      { tipo: "Recibo_Generico",   n:  13, valor:     0.00 },
    ],
    top_emitentes: [
      { nome_emitente: "EDP Comercial SA",       nif_emitente: "501001041", n: 24, valor: 56160.00 },
      { nome_emitente: "Galp Energia SA",         nif_emitente: "500276006", n: 18, valor: 16020.00 },
      { nome_emitente: "MEO SA",                  nif_emitente: "502399694", n: 12, valor: 62400.00 },
      { nome_emitente: "Vodafone Portugal",        nif_emitente: "501003956", n: 10, valor:   784.00 },
      { nome_emitente: "NOS Comunicações SA",      nif_emitente: "508184875", n:  9, valor:  1411.20 },
      { nome_emitente: "Seguradora Fidelidade",    nif_emitente: "500919177", n:  6, valor: 11040.00 },
      { nome_emitente: "Santander Portugal",       nif_emitente: "500843555", n:  5, valor:  2250.00 },
      { nome_emitente: "CTT Expresso SA",          nif_emitente: "502695370", n:  4, valor:   359.60 },
    ],
  };

  // ── Reconciliação / Cruzamento ─────────────────────────────────────────
  if (path.includes("/api/reconciliacao/matches")) return {
    matches: [
      {
        id: 1, estado: "confirmado", confianca: 0.97,
        numero_documento: "FT 2025/1085", nome_emitente: "NOS Comunicações SA",
        valor_total: 156.80, data_documento: "2025-06-13",
        descricao: "NOS COMUNICACOES SA", valor: 156.80, data: "2025-06-13", banco: "CGD",
      },
      {
        id: 2, estado: "confirmado", confianca: 0.94,
        numero_documento: "FT 2025/1080", nome_emitente: "Santander Portugal",
        valor_total: 450.00, data_documento: "2025-06-03",
        descricao: "SANTANDER BANK PAGAMENTO", valor: 450.00, data: "2025-06-04", banco: "BPI",
      },
      {
        id: 3, estado: "pendente", confianca: 0.72,
        numero_documento: "FT 2025/1083", nome_emitente: "MEO SA",
        valor_total: 5200.00, data_documento: "2025-06-11",
        descricao: "MEO SERV COMUNICACOES", valor: 5200.00, data: "2025-06-12", banco: "Millennium",
      },
    ],
    faturas_sem_match: [
      { id: 2, numero_documento: "FT 2025/1086", nome_emitente: "Galp Energia SA",  valor_total: 890.00,  data_documento: "2025-06-14" },
      { id: 4, numero_documento: "FT 2025/1084", nome_emitente: "TMN Portugal SA",  valor_total: 320.00,  data_documento: "2025-06-12" },
      { id: 6, numero_documento: "FT 2025/1082", nome_emitente: "Vodafone Portugal",valor_total: 78.40,   data_documento: "2025-06-10" },
    ],
    extratos_sem_match: [
      { descricao: "PAGAMENTO FORNECEDOR REF 4521", valor: 2340.50, data: "2025-06-16", banco: "CGD" },
      { descricao: "TRANSFERÊNCIA SAÍDA",            valor: 1200.00, data: "2025-06-15", banco: "BPI" },
    ],
  };

  if (path.includes("/api/reconciliacao")) return {
    resumo: { total_faturas: 12, total_extratos: 18, matches_ok: 8, por_confirmar: 3, sem_match: 1 },
    extratos: [
      { id: 1, descricao: "NOS COMUNICACOES SA",           valor: 156.80,  data: "2025-06-13", banco: "CGD"        },
      { id: 2, descricao: "SANTANDER BANK PAGAMENTO",      valor: 450.00,  data: "2025-06-04", banco: "BPI"        },
      { id: 3, descricao: "MEO SERV COMUNICACOES",         valor: 5200.00, data: "2025-06-12", banco: "Millennium" },
      { id: 4, descricao: "PAGAMENTO FORNECEDOR REF 4521", valor: 2340.50, data: "2025-06-16", banco: "CGD"        },
      { id: 5, descricao: "TRANSFERÊNCIA SAÍDA",           valor: 1200.00, data: "2025-06-15", banco: "BPI"        },
    ],
  };

  // ── Sócios ─────────────────────────────────────────────────────────────
  if (path.includes("/api/socios")) return [
    { id: 1, nome: "Henrique Leitão",  email: "henrique@slicedgroup.com", nif: "123456789", ativo: true },
    { id: 2, nome: "João Ferreira",    email: "joao@slicedgroup.com",     nif: "987654321", ativo: true },
  ];

  // ── Pendentes de revisão humana ────────────────────────────────────────
  if (path.includes("/api/pendentes/count")) return { count: 2 };
  if (path.includes("/api/pendentes")) return [
    {
      id: 1,
      motivo: "nif_socio_desconhecido",
      pergunta: "João Ferreira pediu reembolso de 340 € (alojamento). Não está registado como sócio. Pretende registá-lo para receber reembolsos futuros?",
      opcoes: ["Registar como sócio", "Registar apenas esta despesa", "Ignorar"],
      canal: "ambos",
      criada_em: "2026-07-01T09:12:00",
      resposta: null,
      respondida_em: null,
      fatura_id: 4,
      numero_documento: "RV 2026/0034",
      nome_emitente: "João Ferreira",
      nif_emitente: "987654321",
      nome_empresa: "Global Rock Lda",
      valor_total: 340,
      data_documento: "2026-07-01",
    },
    {
      id: 2,
      motivo: "duplicado_provavel",
      pergunta: "A fatura FT 2025/1042 da Galp (1 842 €) parece duplicada — já existe FT 2025/1041 com o mesmo valor e data. Processar mesmo assim?",
      opcoes: ["Processar (não é duplicado)", "Ignorar (é duplicado)"],
      canal: "chat",
      criada_em: "2026-06-30T16:45:00",
      resposta: null,
      respondida_em: null,
      fatura_id: 2,
      numero_documento: "FT 2025/1042",
      nome_emitente: "Galp Energia SA",
      nif_emitente: "500697370",
      nome_empresa: "Everglobal SA",
      valor_total: 1842,
      data_documento: "2026-06-28",
    },
  ];

  // ── Sugestões de pagamento detetadas no corpo de emails ─────────────────
  if (path.includes("/api/sugestoes-pagamento")) return [
    {
      id: 1,
      email_id: "email-mock-1",
      fatura_id: 7,
      numero_documento_mencionado: "FT 2026/0088",
      nif_emitente_mencionado: "500123456",
      trecho_email: "Boa tarde, confirmo que já paguei a fatura FT 2026/0088 por transferência ontem.",
      confianca_deteccao: 1.0,
      estado: "pendente",
      criada_em: "2026-07-20T10:15:00",
      fatura_numero_documento: "FT 2026/0088",
      fatura_valor_total: 452.30,
      fatura_data_documento: "2026-07-15",
      fatura_nome_emitente: "Fornecedor Exemplo Lda",
    },
    {
      id: 2,
      email_id: "email-mock-2",
      fatura_id: null,
      numero_documento_mencionado: "FT-DESCONHECIDA",
      nif_emitente_mencionado: null,
      trecho_email: "Já liquidámos essa fatura na semana passada, obrigado.",
      confianca_deteccao: 0.5,
      estado: "pendente",
      criada_em: "2026-07-19T14:02:00",
    },
  ];

  // ── Reembolsos ─────────────────────────────────────────────────────────
  if (path.includes("/api/reembolsos")) return [
    { id: 1, colaborador: "João Ferreira",   data_despesa: "2026-07-01", descricao: "Hotel Lisboa — reunião clientes", categoria: "alojamento", valor: 340,  empresa_nif: "515775622", estado: "submetido", criado_em: "2026-07-01T09:00:00", notas: "" },
    { id: 2, colaborador: "Henrique Leitão", data_despesa: "2026-06-28", descricao: "Jantar de negócios",              categoria: "alimentação", valor: 87.5, empresa_nif: "515775622", estado: "aprovado",  criado_em: "2026-06-28T20:00:00", notas: "" },
    { id: 3, colaborador: "Ana Costa",       data_despesa: "2026-06-25", descricao: "Transporte aeroporto",            categoria: "transporte",  valor: 45,   empresa_nif: "515824585", estado: "submetido", criado_em: "2026-06-25T14:00:00", notas: "" },
  ];

  // ── Definições / Notificações ──────────────────────────────────────────
  if (path.includes("/api/definicoes/notificacoes")) return {
    email_alertas:    true,
    email_resumo:     true,
    email_erros:      true,
    email_destino:    "henrique@slicedgroup.com",
    freq_resumo:      "diario",
  };

  // ── Utilizadores ───────────────────────────────────────────────────────
  if (path.includes("/api/utilizadores")) return [
    { id: 1, nome: "Henrique Leitão",  email: "henrique@slicedgroup.com", role: "admin", ativo: true },
    { id: 2, nome: "Ana Silva",        email: "ana@slicedgroup.com",       role: "viewer",ativo: true },
  ];

  return null;
}
